import Vue from 'vue';
import {
  Button,
  Layout,
  Header,
  Sider,
  Content,
  Menu,
  Submenu,
  MenuItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Avatar,
  Icon,
  Breadcrumb,
  BreadcrumbItem,
  Tag,
  Tooltip,
  Alert,
  Table,
} from 'view-design';

Vue.component('Button', Button);
Vue.component('Layout', Layout);
Vue.component('Header', Header);
Vue.component('Sider', Sider);
Vue.component('Content', Content);
Vue.component('Menu', Menu);
Vue.component('Submenu', Submenu);
Vue.component('MenuItem', MenuItem);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Avatar', Avatar);
Vue.component('Icon', Icon);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('BreadcrumbItem', BreadcrumbItem);
Vue.component('Tag', Tag);
Vue.component('Tooltip', Tooltip);
Vue.component('Alert', Alert);
Vue.component('Table', Table);
